module.exports = __webpack_public_path__ + "static/media/biglow-woodcraft3.cef34adf.jpg";